module.exports = __webpack_public_path__ + "assets/img/androidDownload.42ec946a.svg";